// Scripts/Components/cookie-banner.ts
// Lógica para el banner de aceptación de cookies

document.addEventListener("DOMContentLoaded", () => {
    const banner = document.getElementById("cookie-banner");
    const acceptBtn = document.getElementById("accept-cookies");
    const rejectBtn = document.getElementById("reject-cookies");
    const closeBtn = document.getElementById("accept-cookies-2");

    if (!banner) return;

    // Verificar si el consentimiento de cookies ya existe
    const hasConsent = localStorage.getItem("cookieConsent");

    if (!hasConsent) {
        // Mostrar el banner con una pequeña demora para permitir una animación suave
        setTimeout(() => {
            banner.classList.remove("translate-y-full", "opacity-0");
            banner.classList.add("translate-y-0", "opacity-100");
        }, 300);
    } else {
        // Si ya hay consentimiento, aseguramos que el banner permanezca oculto
        banner.style.display = "none";
    }

    const hideBanner = () => {
        banner.classList.remove("translate-y-0", "opacity-100");
        banner.classList.add("translate-y-full", "opacity-0");
        setTimeout(() => {
            banner.style.display = "none";
        }, 500);
    };

    // Guardar consentimiento de cookies
    const saveConsent = (isRejectAll = false) => {
        const checkNecessary = document.getElementById("defaultCheck1") as HTMLInputElement | null;
        const checkPreferences = document.getElementById("defaultCheck2") as HTMLInputElement | null;
        const checkStatistics = document.getElementById("defaultCheck3") as HTMLInputElement | null;
        const checkMarketing = document.getElementById("defaultCheck4") as HTMLInputElement | null;
        const checkUnclassified = document.getElementById("defaultCheck5") as HTMLInputElement | null;

        // Si es "Rechazar", deseleccionamos todos los opcionales
        if (isRejectAll) {
            if (checkPreferences) checkPreferences.checked = false;
            if (checkStatistics) checkStatistics.checked = false;
            if (checkMarketing) checkMarketing.checked = false;
            if (checkUnclassified) checkUnclassified.checked = false;
        }

        const consentData = {
            necessary: checkNecessary ? checkNecessary.checked : true,
            preferences: checkPreferences ? checkPreferences.checked : false,
            statistics: checkStatistics ? checkStatistics.checked : false,
            marketing: checkMarketing ? checkMarketing.checked : false,
            unclassified: checkUnclassified ? checkUnclassified.checked : false,
            acceptedAt: isRejectAll ? null : new Date().toISOString(),
            rejectedAt: isRejectAll ? new Date().toISOString() : null
        };

        // Guardar en localStorage
        localStorage.setItem("cookieConsent", JSON.stringify(consentData));

        // Establecer también una cookie HTTP para disponibilidad en servidor
        const maxAge = 365 * 24 * 60 * 60; // 1 año
        document.cookie = `cookie_consent=true; path=/; max-age=${maxAge}; SameSite=Lax`;

        // Ocultar banner
        hideBanner();
    };

    // Eventos
    if (acceptBtn) {
        acceptBtn.addEventListener("click", () => saveConsent(false));
    }

    if (rejectBtn) {
        rejectBtn.addEventListener("click", () => saveConsent(true));
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            // El 'x' solo oculta temporalmente el banner sin registrar consentimiento
            hideBanner();
        });
    }
});
